/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type Block = {
  __typename: "Block",
  zoneId: string,
  blockId: string,
  blockType: BlockType,
  index: number,
  accessLevel: number,
  writeAccessLevel?: number | null,
  groups?: Array< string > | null,
  options?: string | null,
  data?: string | null,
  interactions?: InteractionList | null,
};

export enum BlockType {
  AccessManager = "AccessManager",
  Poll = "Poll",
  Geolocation = "Geolocation",
  InstantMessaging = "InstantMessaging",
  Announcements = "Announcements",
  Content = "Content",
  RSVP = "RSVP",
  Waitlist = "Waitlist",
}


export type InteractionList = {
  __typename: "InteractionList",
  items:  Array<Interaction >,
  nextToken?: string | null,
};

export type Interaction = {
  __typename: "Interaction",
  blockId: string,
  interactionKey: string,
  data?: string | null,
  participantId: string,
  timestamp: number,
  expires?: number | null,
};

export type Zone = {
  __typename: "Zone",
  zoneId: string,
  title: string,
  branding?: string | null,
  blocks:  Array<Block >,
  participants?: ParticipantList | null,
  participation?: Participant | null,
};

export type ParticipantList = {
  __typename: "ParticipantList",
  items:  Array<Participant >,
  nextToken?: string | null,
};

export type Participant = {
  __typename: "Participant",
  zoneId: string,
  participantId: string,
  username?: string | null,
  groups?: Array< string > | null,
  authenticated?: boolean | null,
  active?: boolean | null,
};

export type User = {
  __typename: "User",
  userId: string,
  joinedAt: number,
  username: string,
  email?: string | null,
  avatar?: string | null,
  zoneParticipation:  Array<ZoneParticipation >,
};

export type ZoneParticipation = {
  __typename: "ZoneParticipation",
  zone?: ZoneSummary | null,
  participant?: Participant | null,
};

export type ZoneSummary = {
  __typename: "ZoneSummary",
  zoneId: string,
  title: string,
  branding?: string | null,
};

export type GetBlockInteractionPagingQueryVariables = {
  zoneId: string,
  blockId: string,
  nextToken?: string | null,
  limit?: number | null,
};

export type GetBlockInteractionPagingQuery = {
  getBlock?:  {
    __typename: "Block",
    zoneId: string,
    blockId: string,
    blockType: BlockType,
    index: number,
    accessLevel: number,
    writeAccessLevel?: number | null,
    groups?: Array< string > | null,
    options?: string | null,
    data?: string | null,
    interactions?:  {
      __typename: "InteractionList",
      items:  Array< {
        __typename: "Interaction",
        blockId: string,
        interactionKey: string,
        data?: string | null,
        participantId: string,
        timestamp: number,
        expires?: number | null,
      } >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type GetZoneParticipantPagingQueryVariables = {
  zoneId: string,
  nextToken?: string | null,
  limit?: number | null,
};

export type GetZoneParticipantPagingQuery = {
  getZone?:  {
    __typename: "Zone",
    zoneId: string,
    title: string,
    branding?: string | null,
    participants?:  {
      __typename: "ParticipantList",
      items:  Array< {
        __typename: "Participant",
        zoneId: string,
        participantId: string,
        username?: string | null,
        groups?: Array< string > | null,
        authenticated?: boolean | null,
      } >,
      nextToken?: string | null,
    } | null,
    participation?:  {
      __typename: "Participant",
      zoneId: string,
      participantId: string,
      username?: string | null,
      groups?: Array< string > | null,
      authenticated?: boolean | null,
    } | null,
  } | null,
};

export type AddInteractionMutationVariables = {
  zoneId: string,
  blockId: string,
  interactionKey?: string | null,
  data?: string | null,
};

export type AddInteractionMutation = {
  addInteraction:  {
    __typename: "Interaction",
    blockId: string,
    interactionKey: string,
    data?: string | null,
    participantId: string,
    timestamp: number,
    expires?: number | null,
  },
};

export type JoinZoneMutationVariables = {
  zoneId: string,
  accessManagerBlockId: string,
  asAuthenticated?: boolean | null,
  username?: string | null,
};

export type JoinZoneMutation = {
  joinZone:  {
    __typename: "Participant",
    zoneId: string,
    participantId: string,
    username?: string | null,
    groups?: Array< string > | null,
    authenticated?: boolean | null,
    active?: boolean | null,
  },
};

export type LeaveZoneMutationVariables = {
  zoneId: string,
  accessManagerBlockId: string,
};

export type LeaveZoneMutation = {
  leaveZone:  {
    __typename: "Participant",
    zoneId: string,
    participantId: string,
    username?: string | null,
    groups?: Array< string > | null,
    authenticated?: boolean | null,
    active?: boolean | null,
  },
};

export type CreateZoneMutationVariables = {
  zoneId: string,
  title: string,
  description: string,
  branding?: string | null,
  username?: string | null,
};

export type CreateZoneMutation = {
  createZone?:  {
    __typename: "Zone",
    zoneId: string,
    title: string,
    branding?: string | null,
    blocks:  Array< {
      __typename: "Block",
      zoneId: string,
      blockId: string,
      blockType: BlockType,
      index: number,
      accessLevel: number,
      writeAccessLevel?: number | null,
      groups?: Array< string > | null,
      options?: string | null,
      data?: string | null,
      interactions?:  {
        __typename: "InteractionList",
        items:  Array< {
          __typename: "Interaction",
          blockId: string,
          interactionKey: string,
          data?: string | null,
          participantId: string,
          timestamp: number,
          expires?: number | null,
        } >,
        nextToken?: string | null,
      } | null,
    } >,
    participants?:  {
      __typename: "ParticipantList",
      items:  Array< {
        __typename: "Participant",
        zoneId: string,
        participantId: string,
        username?: string | null,
        groups?: Array< string > | null,
        authenticated?: boolean | null,
        active?: boolean | null,
      } >,
      nextToken?: string | null,
    } | null,
    participation?:  {
      __typename: "Participant",
      zoneId: string,
      participantId: string,
      username?: string | null,
      groups?: Array< string > | null,
      authenticated?: boolean | null,
      active?: boolean | null,
    } | null,
  } | null,
};

export type PutBlockMutationVariables = {
  zoneId: string,
  blockId: string,
  blockType: BlockType,
  index: number,
  accessLevel: number,
  writeAccessLevel?: number | null,
  groups?: Array< string > | null,
  options?: string | null,
  data?: string | null,
};

export type PutBlockMutation = {
  putBlock?:  {
    __typename: "Block",
    zoneId: string,
    blockId: string,
    blockType: BlockType,
    index: number,
    accessLevel: number,
    writeAccessLevel?: number | null,
    groups?: Array< string > | null,
    options?: string | null,
    data?: string | null,
    interactions?:  {
      __typename: "InteractionList",
      items:  Array< {
        __typename: "Interaction",
        blockId: string,
        interactionKey: string,
        data?: string | null,
        participantId: string,
        timestamp: number,
        expires?: number | null,
      } >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateUserMutationVariables = {
  username: string,
  email?: string | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    userId: string,
    joinedAt: number,
    username: string,
    email?: string | null,
    avatar?: string | null,
    zoneParticipation:  Array< {
      __typename: "ZoneParticipation",
      zone?:  {
        __typename: "ZoneSummary",
        zoneId: string,
        title: string,
        branding?: string | null,
      } | null,
      participant?:  {
        __typename: "Participant",
        zoneId: string,
        participantId: string,
        username?: string | null,
        groups?: Array< string > | null,
        authenticated?: boolean | null,
        active?: boolean | null,
      } | null,
    } >,
  } | null,
};

export type KeepAliveMutationVariables = {
  zoneId: string,
  participantId: string,
  ttl?: number | null,
};

export type KeepAliveMutation = {
  keepAlive?:  {
    __typename: "ParticipantList",
    items:  Array< {
      __typename: "Participant",
      zoneId: string,
      participantId: string,
      username?: string | null,
      groups?: Array< string > | null,
      authenticated?: boolean | null,
      active?: boolean | null,
    } >,
    nextToken?: string | null,
  } | null,
};

export type AddPushSubscriptionMutationVariables = {
  zoneId: string,
  pushSubscription: string,
};

export type AddPushSubscriptionMutation = {
  addPushSubscription?:  {
    __typename: "Participant",
    zoneId: string,
    participantId: string,
    username?: string | null,
    groups?: Array< string > | null,
    authenticated?: boolean | null,
    active?: boolean | null,
  } | null,
};

export type RemovePushSubscriptionMutationVariables = {
  zoneId: string,
  pushSubscription: string,
};

export type RemovePushSubscriptionMutation = {
  removePushSubscription?:  {
    __typename: "Participant",
    zoneId: string,
    participantId: string,
    username?: string | null,
    groups?: Array< string > | null,
    authenticated?: boolean | null,
    active?: boolean | null,
  } | null,
};

export type GetZoneQueryVariables = {
  zoneId: string,
};

export type GetZoneQuery = {
  getZone?:  {
    __typename: "Zone",
    zoneId: string,
    title: string,
    branding?: string | null,
    blocks:  Array< {
      __typename: "Block",
      zoneId: string,
      blockId: string,
      blockType: BlockType,
      index: number,
      accessLevel: number,
      writeAccessLevel?: number | null,
      groups?: Array< string > | null,
      options?: string | null,
      data?: string | null,
      interactions?:  {
        __typename: "InteractionList",
        items:  Array< {
          __typename: "Interaction",
          blockId: string,
          interactionKey: string,
          data?: string | null,
          participantId: string,
          timestamp: number,
          expires?: number | null,
        } >,
        nextToken?: string | null,
      } | null,
    } >,
    participants?:  {
      __typename: "ParticipantList",
      items:  Array< {
        __typename: "Participant",
        zoneId: string,
        participantId: string,
        username?: string | null,
        groups?: Array< string > | null,
        authenticated?: boolean | null,
        active?: boolean | null,
      } >,
      nextToken?: string | null,
    } | null,
    participation?:  {
      __typename: "Participant",
      zoneId: string,
      participantId: string,
      username?: string | null,
      groups?: Array< string > | null,
      authenticated?: boolean | null,
      active?: boolean | null,
    } | null,
  } | null,
};

export type GetBlockQueryVariables = {
  zoneId: string,
  blockId: string,
};

export type GetBlockQuery = {
  getBlock?:  {
    __typename: "Block",
    zoneId: string,
    blockId: string,
    blockType: BlockType,
    index: number,
    accessLevel: number,
    writeAccessLevel?: number | null,
    groups?: Array< string > | null,
    options?: string | null,
    data?: string | null,
    interactions?:  {
      __typename: "InteractionList",
      items:  Array< {
        __typename: "Interaction",
        blockId: string,
        interactionKey: string,
        data?: string | null,
        participantId: string,
        timestamp: number,
        expires?: number | null,
      } >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type GetCurrentUserQueryVariables = {
};

export type GetCurrentUserQuery = {
  getCurrentUser?:  {
    __typename: "User",
    userId: string,
    joinedAt: number,
    username: string,
    email?: string | null,
    avatar?: string | null,
    zoneParticipation:  Array< {
      __typename: "ZoneParticipation",
      zone?:  {
        __typename: "ZoneSummary",
        zoneId: string,
        title: string,
        branding?: string | null,
      } | null,
      participant?:  {
        __typename: "Participant",
        zoneId: string,
        participantId: string,
        username?: string | null,
        groups?: Array< string > | null,
        authenticated?: boolean | null,
        active?: boolean | null,
      } | null,
    } >,
  } | null,
};

export type IsPushSubscriptionRegisteredQueryVariables = {
  zoneId?: string | null,
  pushSubscription: string,
};

export type IsPushSubscriptionRegisteredQuery = {
  isPushSubscriptionRegistered?: boolean | null,
};

export type OnInteractionSubscriptionVariables = {
  blockId: string,
};

export type OnInteractionSubscription = {
  onInteraction?:  {
    __typename: "Interaction",
    blockId: string,
    interactionKey: string,
    data?: string | null,
    participantId: string,
    timestamp: number,
    expires?: number | null,
  } | null,
};

export type OnParticipantJoinSubscriptionVariables = {
  zoneId: string,
};

export type OnParticipantJoinSubscription = {
  onParticipantJoin?:  {
    __typename: "Participant",
    zoneId: string,
    participantId: string,
    username?: string | null,
    groups?: Array< string > | null,
    authenticated?: boolean | null,
    active?: boolean | null,
  } | null,
};

export type OnParticipantLeaveSubscriptionVariables = {
  zoneId: string,
};

export type OnParticipantLeaveSubscription = {
  onParticipantLeave?:  {
    __typename: "Participant",
    zoneId: string,
    participantId: string,
    username?: string | null,
    groups?: Array< string > | null,
    authenticated?: boolean | null,
    active?: boolean | null,
  } | null,
};
